const loadingLabel = "Įkeliama";
const ltLT = {
  loadingLabel
};
export {
  ltLT as default,
  loadingLabel
};
